// removed by extract-text-webpack-plugin
module.exports = {"savings-section":"src-components----SavingsSection-module---savings-section---26DCo","container":"src-components----SavingsSection-module---container---3k07T","text-container":"src-components----SavingsSection-module---text-container---1FrhR","message":"src-components----SavingsSection-module---message---udDV0","button":"src-components----SavingsSection-module---button---2p0sZ","savings-slider-container":"src-components----SavingsSection-module---savings-slider-container---3995d","savings-slider":"src-components----SavingsSection-module---savings-slider---1dW4H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SavingsSection.module.scss
// module id = 204
// module chunks = 35783957827783 277043050311175